import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 6,
	viewBox: "0 0 13 6",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.66649 5.7689L8.95369 5.06635L10.5204 3.49967H0.166504V2.4997H10.5204L8.96394 0.933019L9.67674 0.230469L12.4357 2.99969L9.66649 5.7689Z",
		fill: "currentColor"
	})
});
export default SvgArrowLong;
